<template>
  <div>
    <div class="news-style-browser" v-show="artistData.length > 0">
      <div class="title">
        {{ title }}
      </div>
      <div class="flex-browser">
        <div class="nav left" :class="{vizzy: loc > 0, white: white}" v-on:click="goLeft"></div>
        <div class="flex-mover" :class="{mleft: mleft, mright: mright, anim: anim}">
          <div class="flex-images" >
            <az-image v-for="item in currentArtists" :key="item.artist_id" :artist="item" v-on:click="goItem(item)" />
            <div v-for="n in extraImages" :key="'xtra' + n" class="imdiv"></div>
          </div>
        </div>
        <div class="nav right" :class="{vizzy: loc < artistData.length - cols, white: white}" v-on:click="goRight"></div>
      </div>
    </div>
  </div>
</template>

<script>
import ViewablePanel from '@/mixins/ViewablePanel.js'
import AzImage from '@/components/widgets/AzImage.vue'
import '@/css/image-browser.css'

export default {
  mixins:[ViewablePanel],
  props:{
    title: String,
    artists: Array,
    artist: Object,
    white: Boolean
  },
  components: {
    AzImage
  },
  data () {
    return {
      currentArtists: [],
      artistData:[],
      loc: 0,
      cols: 3,
      mleft: false,
      anim: false,
      mright: false,
      loaded: false,
      extraImages: 0
    }
  },
  mounted () {
    this.setCols()
    this.loaded = false
    if(this.inView) {
      if(!this.loaded) {
        this.loaded = true
        this.loadData()
      }
    }
    window.addEventListener('resize', this.setCols)
  },
  methods: {
    setCols () {
      let wd = window.innerWidth
      this.cols = 3
      if(wd > 1100) this.cols = 4
      if(wd > 1300) this.cols = 5;
      if(this.currentArtists.length > 0){
        this.currentArtists = this.artistData.slice(this.loc, this.loc + this.cols)
      }
    },
    async loadData () {
      if(!this.artists) return
      let artists = []
      for(var each of this.artists) {
        let a = await this.$store.dispatch('fetchArtist', each)
        if(a){
          artists.push(a)
        }
      }
      let lang = this.$store.state.lang.toLowerCase()
      artists = artists.filter(el => { return  !el.hiddens.includes(lang) })
      this.artistData = artists
      this.currentArtists = this.artistData.slice(this.loc, this.loc + this.cols)
      if(this.artistData.length < this.cols) {
        this.extraImages = this.cols - this.artistData.length
      }
    },
    async goItem(artist) {
      this.$k.sendGaEvent('ArtistPortfolio', 'Clicked', 'YouMightAlsoLike');
      
      this.$ixr.push('/artists/' + artist.portfolio_url)

    },
    async goRight () {
      this.anim = true
      this.mleft = true
      await this.$k.waitfor(200)
      this.anim = false
      this.loc++
      this.currentArtists = this.artistData.slice(this.loc, this.loc + this.cols)
      this.mleft = false
    },
    async goLeft () {
      this.anim = true
      this.mright = true
      await this.$k.waitfor(200)
      this.anim = false
      this.loc--
      this.currentArtists = this.artistData.slice(this.loc, this.loc + this.cols)
      this.mright = false
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.setCols)
    }
  },
  watch: {
    artists () {
      this.loaded = false
      this.loc = 0
      this.artistData = []
      this.currentArtists = []
    },
    inView () {
      if(this.inView) {
         if(!this.loaded) {
          this.loaded = true
          this.loadData()
        }
      }
    }
  }
}
</script>

<style>

</style>